<template>
  <v-row no-gutters>
    <v-col cols="12">
      <file-upload
          :input-id="id"
          class="btn btn-primary input"
          :class="{'inputWarn': required && files.length <= 0}"
          :multiple="true"
          :disabled="disabled"
          v-model="attached"
          @input-file="inputFile"
          ref="upload"
      >
        <i class="fa fa-plus"></i>
        Seleziona file
      </file-upload>
    </v-col>
    <v-col cols="12" v-for="(file, index) in uploaded" :key="index">
      <v-row no-gutters align="center">
        <v-col class="filename" cols="9">
          <span>{{index + 1}}</span> -
          <span>{{file.substring(file.lastIndexOf("%2F") + 3).split('?alt')[0]}}</span>
        </v-col>
        <v-col cols="3" class="text-right">
          <v-btn
              fab
              depressed
              dark
              small
              icon
              color="primary"
              target="_blank"
              :href="file"
          >
            <v-icon dark>
              mdi-file-document
            </v-icon>
          </v-btn>
          <v-btn
              fab
              depressed
              dark
              small
              icon
              v-if="!disabled"
              color="error"
              @click.prevent="remove(index)"
          >
            <v-icon dark>
              mdi-delete
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" v-for="(file, index) in attached" :key="file.id">
        <v-row no-gutters align="center">
          <v-col class="filename" cols="9">
            <span>{{uploaded.length + index + 1}}</span> -
            <span>{{file.name}}</span>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-btn
                fab
                depressed
                dark
                small
                icon
                color="error"
                @click.prevent="$refs.upload.remove(file)"
            >
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
  .filename {
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>

<script>
import FileUpload from 'vue-upload-component'
export default {
  name:'input-file',
  components: {
    FileUpload
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    files: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    if(this.check && this.files.length > 0 && !this.files[0].file) {
      this.check = false
      this.uploaded.concat(this.files)
      this.files.forEach(elm => {
        this.uploaded.push(elm)
      });
    } else if(this.check && this.files.length > 0 && this.files[0].file) {
      this.check = false
      this.files.forEach(elm => {
        this.attached.push(elm)
      });
    }
  },
  watch: {
    files() {
      if(this.check && this.files.length > 0 && !this.files[0].file) {
        this.check = false
        this.uploaded.concat(this.files)
        this.files.forEach(elm => {
          this.uploaded.push(elm)
        });
      }
      if(this.files.length === 0) {
        this.$refs.upload.clear()
      }
    }
  },
  methods: {
    inputFile() {
      this.$emit('update:files', this.uploaded.concat(this.attached));
    },
    remove(index) {
      this.uploaded.splice(index, 1)
      this.$emit('update:files', this.uploaded.concat(this.attached));
    }
  },
  data() {
    return {
      check: true,
      attached: [],
      uploaded: [],
    }
  }
}
</script>


